// @ts-nocheck
import { useNavigate } from "react-router-dom";
import "./index.css";

export default function TopBar({ title, isBack, theme = 'light', rightContent }: {
  title: string;
  isBack: boolean;
  theme?: 'light' | 'dark';
  rightContent?: React.ReactNode;
}) {
  const navigate = useNavigate();
  const isDark = theme === 'dark';
  
  return (
    <div className="topbarnew-1">
      <div className={`topbarnew-2 ${isDark ? 'dark' : ''}`}>
        <div className="topbarnew-3"></div>
        <div className="topbarnew-4">
          {isBack && (
            <div
              className="topbarnew-5"
              onClick={() => {
                navigate(-1);
              }}
            >
              <div className="topbarnew-6">
                <div className="topbarnew-7">
                  <div className={`topbarnew-8 ${isDark ? 'dark' : ''}`}>
                    <span className="topbarnew-9"></span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="topbarnew-10">
            <div className={`topbarnew-11 ${isDark ? 'dark' : ''}`}>{title}</div>
          </div>
          <div className="pr-2">
            {rightContent}
          </div>
        </div>
      </div>
      <div className="topbarnew-14"></div>
    </div>
  );
}
